module.exports = __webpack_public_path__ + "img/ИФ-1(А)-039.daf193b8.png";